<script>
  let { onUpgrade } = $props();
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import TrialEndedContent from "./TrialEndedContent.svelte";
  import TrialEndingContent from "./TrialEndingContent.svelte";

  userStore.once();
</script>

{#if $userStore.plgTrialDaysRemaining === 0}
  <TrialEndedContent {onUpgrade} />
{:else}
  <TrialEndingContent {onUpgrade} />
{/if}
